module.exports = __webpack_public_path__ + "img/check-icon.3aee1ea8.png";